import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

/**
 * Formatea fechas con moment.js en locale 'es'.
 * Uso: {{ session.createdAt | dateToMoment }}
 *      {{ session.createdAt | dateToMoment: 'DD/MM/YYYY' }}
 *      {{ session.createdAt | dateToMoment: 'fromNow' }}
 */
@Pipe({ name: 'dateToMoment' })
export class DateToMomentPipe implements PipeTransform {
  transform(value: Date | string | null | undefined, format = 'DD/MM/YYYY HH:mm'): string {
    if (!value) return '';
    const date = moment(value);
    if (!date.isValid()) return '';
    return format === 'fromNow' ? date.fromNow() : date.format(format);
  }
}
